module.exports = __webpack_public_path__ + "img/img-624706.jpg";